import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M0 20a19.9 19.9 0 0 0 2.432 9.565L20 31.305l17.568-1.74A19.91 19.91 0 0 0 40 20l-20-1.74L0 20Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#338AF3",
  d: "M37.568 10.435C34.176 4.218 27.581 0 20 0 12.42 0 5.824 4.218 2.432 10.435A19.91 19.91 0 0 0 0 20h40c0-3.465-.882-6.724-2.432-9.565Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#496E2D",
  d: "M20 40c7.58 0 14.176-4.218 17.568-10.435H2.432C5.824 35.782 12.419 40 20 40Z"
}, null, -1), d = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "m22.609 11.705 2.442 1.149-1.3 2.365 2.652-.507.336 2.68 1.848-1.971 1.847 1.97.336-2.679 2.652.507-1.3-2.365 2.442-1.15-2.442-1.148 1.3-2.366-2.652.508-.336-2.68-1.848 1.971-1.847-1.97-.336 2.679-2.652-.508 1.3 2.366-2.442 1.149Z"
}, null, -1), i = [
  n,
  c,
  s,
  d
];
function _(h, r) {
  return e(), l("svg", o, [...i]);
}
const f = { render: _ };
export {
  f as default,
  _ as render
};
